module.exports = __webpack_public_path__ + "static/media/14-iveco.d5fe96d1.jpg";